import { Component, HostListener, OnInit } from '@angular/core';
import { ResponsiveService } from '../../../_services/responsive.service';
import { ActivatedRoute } from '@angular/router';
import { EnvService } from 'src/app/_services/env.service';
import { CiamService } from 'src/app/_services/ciam.service';
import { CustomerRegistrationSource } from 'src/publicproxy/src/proxy/public/application/contracts/customer-registration-source.enum';

@Component({
  selector: 'ng-casto-customer-login',
  templateUrl: './login.component.html'
})
export class CustomerLoginComponent implements OnInit {

  protected readonly LoginContext = LoginContextEnum;
  contexts: LoginContextEnum[] = [];
  roles: string[] = [];
  loading = false;

  constructor(
    public responsive: ResponsiveService,
    private route: ActivatedRoute,
    private envService: EnvService,
    private readonly ciamService: CiamService,
  ) { }

  /** Revenu par « Précédent », le navigateur restaure la page telle qu'on l'a quittée, bouton en chargement compris. */
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      let source: CustomerRegistrationSource;
      if (params.source) {
        source = CustomerRegistrationSource[params.source.toLowerCase() as keyof typeof CustomerRegistrationSource];
      }

      if (!source) {
        source = CustomerRegistrationSource.qrcode;
      }

      const store = source === CustomerRegistrationSource.qrcode ? params.magasin : undefined;
      const sector = store ? params.secteur : undefined;
      this.envService.saveRegistrationContext(source, store, sector);
    });

    if (!this.responsive.isMobile) {
      this.contexts = [LoginContextEnum.login, LoginContextEnum.createCard];
    }
  }

  createCard(): void {
    this.loading = true;
    this.ciamService.redirectToRegister('/creation');
  }

  /**
   * Gestion des components affiché
   * @param context
   */
  switchContext(context: LoginContextEnum): void {
    if (this.responsive.isMobile) {
      this.contexts = [context];
    } else {
      if (this.contexts.length === 1 && context === LoginContextEnum.login) {
        this.contexts = [context, LoginContextEnum.createCard];
        return;
      }

      this.contexts.push(context);

      switch (context) {
        case LoginContextEnum.login:
          this.contexts = this.contexts.filter(c => c != LoginContextEnum.forgottenPassword);
          break;

        case LoginContextEnum.forgottenPassword:
          this.contexts = this.contexts.filter(c => c != LoginContextEnum.login);
          break;
      }
    }
  }
}

export enum LoginContextEnum {
  login,
  forgottenPassword,
  createCard
}
